import CustomSpin from '../../../../elements/CustomSpin'
import ShippingDetails from '../../../../elements/ShippingDetails'
import withFormItemView from 'form-item-view-hoc'
import React, { useEffect } from 'react'
import { Checkbox, Col, Form, Input, InputNumber, Row } from 'antd'
import { get, isEmpty, round } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import Corporate from '../../../../api/Corporate'
import { numVal, strVal } from '../../../../modules/Utils'
import TaxTypeSelect from '../../../../elements/Select/Lines/TaxType'
import { compose } from 'recompose'

const CustomFormItem = compose(withFormItemView)(Form.Item)

const { TextArea } = Input

const corporateApi = new Corporate()

function ProductLinesForm (props) {
  const { line, product, formGen, fetchingForm } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form
  const companyKey = strVal(product, 'company._id').replace('members/', '')
  const { object: corporate, fetching, fetch } = useFetchObject(
    () => corporateApi.getByOwner(companyKey),
    false,
    [companyKey],
    isEmpty(companyKey),
  )
  const productName = get(product, 'name')

  /*useEffect(() => {
    if (!isEmpty(productName) && !isEmpty(uom) && !isEmpty(currency) && !isEmpty(taxType)) {
      const name = `${productName} (${uom}) - ${currency} [TAX ${taxType}]`
      setFieldsValue({ name })
    }
  }, [productName, uom, currency, taxType])*/
  console.log(get(line, 'shipping'), line)
  return (
    <CustomSpin spinning={fetchingForm}>
      <Form>
        <ShippingDetails
          line={line}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'product',
          }}
        />
      </Form>
    </CustomSpin>
  )
}

ProductLinesForm.propTypes = {}
ProductLinesForm.defaultProps = {}

export default Form.create()((ProductLinesForm))
